
import ContactForm from "@/components/base/form/ContactForm"
export default {
    name: "ContactFormBasicBlok",
    components: { ContactForm },
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
}
